var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallaetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.141,
    height: 41.655,
    viewBox: "0 0 42.141 41.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallaet_icon",
    "data-name": "Wallaet icon",
    transform: "translate(-106.591 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M30.821,9.81H4.61c-.195,0-.391-.01-.583.008a1.271,1.271,0,0,0-1.17,1.225,1.241,1.241,0,0,0,1.082,1.243,4.5,4.5,0,0,0,.688.03h32.9c2.914,0,4.6,1.683,4.61,4.6.005,2.246.012,4.492-.014,6.737a1.2,1.2,0,0,1-.331.765q-8.6,8.428-17.242,16.819a1.379,1.379,0,0,1-.872.348c-6.35.019-12.7-.042-19.049.04A4.37,4.37,0,0,1,.014,37.024c.017-1.75,0-3.5,0-5.252C.017,24.628.047,17.484,0,10.34A4.92,4.92,0,0,1,2.952,5.557,17.647,17.647,0,0,1,7.421,4.292C12.758,3.155,18.1,2.031,23.433.883c.983-.211,1.945-.517,2.92-.767a3.507,3.507,0,0,1,4.415,3.319c.047,2,.051,4,.073,5.994,0,.1-.011.207-.02.382",
    transform: "translate(106.591 32)",
    fill: "rgba(5,26,53,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M69.949,55.152c0,3.428.047,6.7-.017,9.969a4.313,4.313,0,0,1-4.072,4.1c-3.375.08-6.753.021-10.274.021l14.363-14.09",
    transform: "translate(78.766 4.392)",
    fill: "rgba(5,26,53,0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallaetIcon);
export default __webpack_public_path__ + "static/media/Wallaet_icon.1cef2ec2660f19bea698dbe6d33b38a5.svg";
export { ForwardRef as ReactComponent };